import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const MuteIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 4.19999C10.9 3.89999 11.6 3.79999 12.1 3.99999C12.6 4.19999 13 4.79999 13 5.29999V18.8C13 19.4 12.6 20 12.1 20.2C11.9 20.3 11.7 20.3 11.5 20.3C11.1 20.3 10.8 20.1 10.5 19.9L10.4 19.8L6.5 15.4H4.5C3.7 15.4 3 14.7 3 13.8V10.3C3 9.39999 3.7 8.69999 4.5 8.59999H6.5L10.5 4.19999ZM5 13.4H6V10.7H5V13.4ZM8 14L11 17.4V6.59999L8 9.99999V14ZM20.7 11L19.7 12L20.7 13C21.2 13.4 21.2 14.1 20.8 14.5C20.4 14.9 19.7 14.8 19.3 14.4L18.3 13.4L17.3 14.4C16.9 14.9 16.2 14.9 15.8 14.5C15.4 14.1 15.5 13.4 15.9 13L16.9 12L15.9 11C15.4 10.6 15.4 9.9 15.8 9.5C16.2 9.1 16.9 9.2 17.3 9.6L18.3 10.6L19.3 9.6C19.7 9.1 20.4 9.1 20.8 9.5C21.2 9.9 21.1 10.6 20.7 11Z"
      />
    </Icon>
  );
};
